module.exports = __webpack_public_path__ + "img/ds_special.e4aafd2b.png";